<template>
  <div>
    <headers></headers>
    <div class="padding250">
      <div class="auto">
        <div class="titleWrap">
          <p class="titleName">活动申报</p>

        </div>
        <ul>
          <li><img src="../../assets/success.png" alt=""></li>
          <li>恭喜您，提交成功！</li>
          <li>公司将在1-2个工作日内与您取得联系 <br>或直接拨打客服电话：400-888-9999</li>
          <li style="display: none;">工作人员将在1-2个工作日内审核 <br>或直接拨打客服电话：400-888-9999</li>
        </ul>
        <router-link to="/jilushenbao">查看申报记录</router-link>
        <router-link to="/ziliao/mykaoshi" style="display: none;">返回考试详情</router-link>
      </div>

    </div>

     <footers></footers>
  </div>
</template>

<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'
  export default {
    name: '',
    props: {},
    data() {
      return {
        formValidate: {
          radio: 'yes'
        }
      };
    },
    methods: {},
    created() {

    },
   components: {
     headers,
     footers
   }
  }
</script>


<style scoped lang="less" rel="stylesheet/less">
  .auto{
    background: #fff;
    margin-top: 30px;
    padding: 40px;
    .titleWrap {
      height: 40px;
      font-size: 20px;
      padding-bottom: 20px;
      color: #333;
      text-align: justify-all;
      border-bottom: 1px solid #E1E1E1;
      margin-bottom: 30px;
      .titleName {
        float: left;
        line-height: 24px;
      }

    }
  }
  ul{
    text-align: center;
    padding-top: 50px;
    li:nth-child(2){
      font-size: 24px;
      color: #000;
      margin: 30px 0;
    }
    li:last-child{
      font-size: 14px;
      color: #666;
    }
  }
  a{
    display: block;
    border-radius: 5px;

    font-size: 18px;
    color: #0F426D;
    border:1px solid #0F426D;
    width: 220px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    margin:100px  auto 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/education/shenbaosuccess.vue